<script>
  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher()

  export let items
  export let activeTab
  export let hasFilters = true
  export let textColor
</script>

<style>
  :global(.tab__wrapper-pdFrcJ) {
    border-bottom: 0.4px solid #e8ebed;
    display: flex;
    align-items: center;
  }

  :global(.tab__wrapper-pdFrcJ) span {
    font-size: 14px;
    cursor: pointer;
    float: left;
    padding: 11px 18px;
    font-weight: 400;
    user-select: none;
    -webkit-user-select: none;
  }

  :global(.tab__wrapper-pdFrcJ) span.active {
    border-bottom: 2px solid #0b6a68;
  }
</style>

<div class="tab__wrapper-pdFrcJ">
  <div class="" style="color: {textColor};">
    {#each items as item, index (index)}
      {#if item.show}
        <span
          class:active={item.label === activeTab}
          on:click={() => dispatch('tabChanged', item)}>
          {item.label}
          {#if item.count > 0}({item.count}){/if}
        </span>
      {/if}
    {/each}
  </div>
  {#if hasFilters}
    <slot />
  {/if}
</div>
